import { useEffect, useMemo, useState } from 'react';

export const useBootcampTablePagination = (rows = [], { pageSize = 10, searchFields = [] } = {}) => {
  const [search, setSearchState] = useState('');
  const [page, setPage] = useState(1);

  useEffect(() => {
    setPage(1);
  }, [rows]);

  const filteredRows = useMemo(() => {
    const query = search.trim().toLowerCase();
    if (!query) {
      return rows;
    }

    return rows.filter((row) =>
      searchFields.some((field) => String(row[field] || '').toLowerCase().includes(query))
    );
  }, [rows, search, searchFields]);

  const totalPages = Math.max(1, Math.ceil(filteredRows.length / pageSize));
  const safePage = Math.min(page, totalPages);

  const paginatedRows = useMemo(() => {
    const start = (safePage - 1) * pageSize;
    return filteredRows.slice(start, start + pageSize);
  }, [filteredRows, safePage, pageSize]);

  const setSearch = (value) => {
    setSearchState(value);
    setPage(1);
  };

  return {
    search,
    setSearch,
    page: safePage,
    setPage,
    totalPages,
    paginatedRows,
    filteredCount: filteredRows.length,
    totalCount: rows.length,
    isEmpty: filteredRows.length === 0,
  };
};
